import { useLocation, useNavigate } from "react-router-dom";

interface childItem {
  id: string;
  label: string;
  path?: string;
  notifition?: string;
}
interface sidebarDropdownProps {
  data: childItem[];
  isOpen: boolean;
  notifications: string[];
  parentNotificationKeys?: string[];
  isParentDisabled?: boolean;
  isRestrictedRole?: boolean;
  restrictedRoleAllowedChildren?: string[];
}

interface ChildButtonProps {
  child: childItem;
  notifications: string[];
  parentNotificationKeys: string[];
  isParentDisabled?: boolean;
  isRestrictedRole?: boolean;
  restrictedRoleAllowedChildren?: string[];
}

function ChildButton({ child, notifications, parentNotificationKeys, isParentDisabled = false, isRestrictedRole = false, restrictedRoleAllowedChildren = [] }: ChildButtonProps) {

  const navigate = useNavigate();
  const location = useLocation();
  const isActive = !!child.path && child.path === location.pathname;

  const childNotifKey = child.notifition?.trim() || "";
  const hasChildOwnNotification = childNotifKey.length > 0 && notifications.includes(childNotifKey);
  const hasParentNotification = !hasChildOwnNotification && parentNotificationKeys.length > 0 && parentNotificationKeys.some((key) => notifications.includes(key));
  const hasNotification = hasChildOwnNotification || hasParentNotification;
  const isDisabled =
    isParentDisabled ||
    (isRestrictedRole && !restrictedRoleAllowedChildren.includes(child.id));

  return (
    <button
      type="button"
      onClick={(e) => {
        if (isDisabled) return;
        if (child.path) navigate(child.path);
      }}
      title={isDisabled ? "شما دسترسی ندارید" : ""}
      className={`flex w-full relative items-center justify-between rounded-md py-1 px-2 text-right text-sm transition-colors duration-200
        ${isDisabled ? "cursor-not-allowed opacity-60" : "hover:bg-primaryVar-50"}
        ${isActive ? "text-primaryVar" : "text-gray-500"}`}
    >
      <span className="text-xs">{child.label}</span>
      {hasNotification && (
        <span className="h-2 w-2 rounded-full bg-errorVar absolute -right-2"></span>
      )}
    </button>
  );
};

export default function AdminLayoutSideBarItemDropdown({ data, isOpen, notifications, parentNotificationKeys = [], isParentDisabled = false, isRestrictedRole = false, restrictedRoleAllowedChildren = [] }: sidebarDropdownProps) {
  return (
    <div
      className={`flex w-full flex-col gap-1 overflow-hidden pr-10 transition-all duration-200 ease-out ${
        isOpen
          ? "max-h-96 opacity-100"
          : "pointer-events-none max-h-0 opacity-0"
      }`}
    >
      {data.map((child) => (
        <ChildButton
          key={child.id}
          child={child}
          notifications={notifications}
          parentNotificationKeys={parentNotificationKeys}
          isParentDisabled={isParentDisabled}
          isRestrictedRole={isRestrictedRole}
          restrictedRoleAllowedChildren={restrictedRoleAllowedChildren}
        />
      ))}
    </div>
  );
};